module.exports = __webpack_public_path__ + "static/img/neil_findworka.8ec9e10.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/neil_findworka.jpg
// module id = U1lR
// module chunks = 1